exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qiankun-demo .style-test{color:#00f}.microApp-container,.microApp-container div[data-name^=microApp]{height:100%}", ""]);

// exports
